import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  ExtendedFlex,
  Heading,
  Switch,
} from '../../coreui';

import actions from '../actions';

class DistributionsToggle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: this.props.dripSetting,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(checked) {
    this.setState({
      checked,
    });
    const callback = checked ?
      this.props.reinvestDistributionsURL : this.props.receiveCashDistributionsURL;
    this.props.dripToggleRequested({ id: this.props.id, callback });
  }

  render() {
    const {
      isDisabled,
    } = this.props;

    return (
      <ExtendedFlex
        flexDirection="row"
        align="center"
        justify={['space-between', 'flex-start']}
        mt={10}
      >
        <Heading
          type="H6"
          m={0}
          mr={[5, 5, 15]}
        >
          Reinvest Distributions?
        </Heading>
        <Switch
          disabled={isDisabled}
          label="Reinvest Distributions?"
          checked={this.state.checked}
          onChange={this.handleChange}
          on="Yes"
          off="No"
        />
      </ExtendedFlex>
    );
  }
}

DistributionsToggle.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  isDisabled: PropTypes.bool,
  dripSetting: PropTypes.bool,
  reinvestDistributionsURL: PropTypes.string,
  receiveCashDistributionsURL: PropTypes.string,
  dripToggleRequested: PropTypes.func,
};

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dripToggleRequested: ({ id, callback }) => {
      dispatch(actions.dripToggleApiActionRequested({ id, callback }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DistributionsToggle);
